module.exports = __webpack_public_path__ + "img/mk-bg-03.b4b05cf7.png";